import React, { useState } from "react";
import policyContent from "../data/policyContent.json";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";

const InternshipPolicyPage = () => {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = () => {
    setAgreed(!agreed);
  };

  const handleSubmit = () => {
    //TODO Handle submission logic here
    navigate("/application-page");
    console.log("Policy agreed, proceeding to application.");
  };
  const handlejobClick = () => {
    //TODO Remember To remove
    navigate("/job-application-page");
  };
  const handlejob2Click = () => {
    //TODO Remember To remove
    navigate("/manage-jobs");
  };

  return (
    <div>
      <Header />
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="policy-page p-4 md:p-8 bg-white shadow-md max-w-7xl w-full">
          <h2 className="text-xl lg:text-2xl font-bold mb-4 text-gray-600 text-center">
            East African Community (EAC) Internship Program
          </h2>
          <p className="text-gray-600">
            Welcome to the East African Community (EAC) Internship Program. The
            EAC is committed to providing a structured and valuable internship
            experience to students and recent graduates. This policy outlines
            the terms and conditions for interns joining the organization."
          </p>
          <br />
          {/* Json Policy Content */}
          {policyContent.content.map((item, index) => (
            <div key={index} className="mb-5">
              <h3 className="text-base lg:text-lg text-gray-600  font-semibold">
                {item.section}
              </h3>
              {item.paragraphs.map((paragraph, pIndex) => (
                <p key={pIndex} className="mb-2 text-gray-500">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
          <p className="text-gray-600">
            By accepting the terms and conditions of this policy, you agree to
            comply with all the outlined rules and responsibilities. Should you
            have any questions regarding the terms, please contact the
            Internship Coordinator.
          </p>
          {/* Agreement Section */}
          <div className="agreement mb-4 mt-10 flex items-center justify-center pt-4">
            <input
              type="checkbox"
              checked={agreed}
              onChange={handleCheckboxChange}
              className="h-5 w-5 text-green-600 focus:ring-green-500 border-gray-300 rounded"
            />
            <label
              htmlFor="declareAccuracy"
              className="ml-3 font-semibold  text-gray-700"
            >
              I confirm that I have read, understood, and accepted this policy.
            </label>
          </div>
          <div className="button-container text-center items-center mt-8 mb-10">
            <button
              className={`continue-btn md:text-base text-sm  rounded-[16px] p-3 md:p-3 px-9 md:px-14 font-semibold text-white bg-[rgba(12,115,38,0.911)] ${
                !agreed ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={!agreed}
              onClick={handleSubmit}
            >
              Continue to Application
            </button>
            {/* //TODO: Remember to remove */}
            {/* <button onClick={handlejobClick} className="text-white">job page</button>
            <button onClick={handlejob2Click} className="text-white">job MGT page</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternshipPolicyPage;
